import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_SMART_CAR(state, smartCar) {
    state.cached = smartCar
  },
}

export const actions = {
  init({ state, dispatch }) {},
  fetchCardholders(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_smart_car/cardholder/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_SMART_CAR', request)
      return request
    })
  },
  manualCreateEuroSmartCarCardholders(context, formData) {
    let promise = null
    promise =  axios.post(`${serverUrl}/euro_smart_car/cardholder/manual_create/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },
  manualDeleteEuroSmartCarCardholders(context, formData) {
    let promise = null
    promise =  axios.post(`${serverUrl}/euro_smart_car/cardholder/manual_delete/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },
  fetchCardholderDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },
}